export default {
  CADASTRAL_NUMBER: '1',
  CONVENTIONAL_NUMBER: '2',
  INVENTORY_NUMBER: '3',
  NO_NUMBER: '4',
};
